import React from 'react';
import {Stack} from '@lapilli-ui/components';
import parse from 'html-react-parser';

import {ywcasDefaultSettings} from '../../../config';

import {useMediaQuery} from '../../utils/functions';

const ItemThumb = ({imageSize, marginLeft, item}) => {
  const productInStock = Boolean(parseInt(item.instock));
  const isSmallDevice = useMediaQuery('(max-width: 500px)');
  const imageWidth = isSmallDevice ? '70' : imageSize;

  return (<Stack className="search-result-item__thumbnail" sx={{width: imageWidth, marginLeft}}>
    <img src={item.thumbnail} alt={item.name} width={imageWidth}/>
  </Stack>);
};

export default ItemThumb;